import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createForm: false,
  createDistributeId: null,
  editObj: null,
  paymentCreateForm: false,
  paymentEditObj: null,
  report: false,
};

export const distributeSlice = createSlice({
  name: "distribute",
  initialState,
  reducers: {
    showPaymentCreateForm: (state) => {
      state.paymentCreateForm = !state.paymentCreateForm;
    },
    showDistributeCreateForm: (state) => {
      state.createForm = !state.createForm;
    },
    showReportForm: (state) => {
      state.report = !state.report;
    },
    setDistributeId: (state, { payload }) => {
      state.createDistributeId = payload;
    },
    setDistributeObj: (state, { payload }) => {
      console.log("wooorking");
      state.editObj = payload;
    },
    setPaymentObj: (state, { payload }) => {
      state.paymentEditObj = payload;
    },
  },
  extraReducers: (builder) => {},
});

export const {
  showDistributeCreateForm,
  setDistributeObj,
  setDistributeId,
  showPaymentCreateForm,
  setPaymentObj,
  showReportForm,
} = distributeSlice.actions;
export default distributeSlice.reducer;
